export * from './awards.module';
export * from './shared';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/awards/index.ts